import React, {useState} from 'react';

function ContractUpcomingDates({ dates }) {
    const [showAll, setShowAll] = useState(false);
    const [showAllPastDates, setShowAllPastDates] = useState(false);

    const excludeDates = ['mineral_rights_examination_deadline', 'water_rights_examination_deadline', 'seller_or_private_financing_deadline', 'right_of_first_refusal_deadline', 'association_document_deadline', 'association_documents_termination_deadline', 'seller_property_disclosure_deadline', 'lead_based_paint_disclosure_deadline', 'disapproval_of_buyers_credit_information_deadline', 'existing_loan_deadline', 'existing_loan_termination_deadline', 'loan_transfer_approval_deadline', 'property_insurance_termination_deadline', 'conditional_sale_deadline'];

    // ORIGINAL Filter and sort the dates
    // const allDates = Object.entries(dates)
    //     .filter(([title, date]) => !isNaN(new Date(date)) && !excludeDates.includes(title))
    //     .sort((a, b) => new Date(a[1]) - new Date(b[1]));
    const allDates = Object.entries(dates)
    .filter(([title, data]) => !isNaN(new Date(data.date)) && !excludeDates.includes(title))
    .sort((a, b) => new Date(a[1].date) - new Date(b[1].date))
    .map(([title, data]) => ({title, ...data}));


    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const currentAndUpcomingDates = allDates.filter(({date}) => new Date(date) >= today);
    const pastDates = allDates.filter(({date}) => new Date(date) < today);

    function formatTitle(title) {
        return title
            .replace(/_/g, ' ')
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
            .replace(/ Deadline$/, '');  // Remove " Deadline" from the end of the title
    }

    function formatDate(dateString) {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const date = new Date(dateString);
        const utcDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
        return utcDate.toLocaleDateString(undefined, options);
    }

    return (
        <div className='flex-col'>
            <h1 className='text-[18px] md:text-2xl font-semibold mb-1 md:mb-3'>Your Key Deadlines</h1>
            <div className="flex-col items-center mb-2">
                <p className='text-sm text-slate-600'>Next Deadline:</p>
                <div className=" bg-blue-100 text-blue-600 rounded-xl p-1 text-[14px] w-auto">
                {currentAndUpcomingDates?.length > 0 ? `${formatDate(currentAndUpcomingDates[0].date)} - ${formatTitle(currentAndUpcomingDates[0].title)}` : 'No upcoming dates'}
                </div>
            </div>
            <table className="w-full grid grid-cols-1">
                <tbody>
                    {(showAll ? currentAndUpcomingDates : currentAndUpcomingDates.slice(1, 6)).map(({title, date}) => {
                        const formattedTitle = formatTitle(title);
                        const formattedDate = formatDate(date);

                        return (
                            <tr key={title} className='flex py-2'>
                                <td className='text-sm font-[Inter]'>{formattedDate} - </td>
                                <td className='text-sm font-[Inter]'>{formattedTitle}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            {currentAndUpcomingDates?.length > 5 && (
                <button 
                    className='text-sm text-shi-green hover:underline mt-2 text-left w-full'
                    onClick={() => setShowAll(!showAll)}
                >
                    {showAll ? 'See Less' : 'See All'}
                </button>
            )}
            
            <h2 className='text-[18px] md:text-xl font-semibold mt-5 mb-3'>Past Deadlines</h2>
            <table className="w-full grid grid-cols-1">
                <tbody>
                    {(showAllPastDates ? pastDates : pastDates.slice(0, 5)).map(({title, date}) => {
                        const formattedTitle = formatTitle(title);
                        const formattedDate = formatDate(date);

                        return (
                            <tr key={title} className='flex py-2'>
                                <td className='text-sm font-[Inter]'>{formattedDate} - </td>
                                <td className='text-sm font-[Inter]'>{formattedTitle}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
                {pastDates?.length > 5 && (
                <button 
                    className='text-sm text-shi-green hover:underline mt-2 text-left w-full'
                    onClick={() => setShowAllPastDates(!showAllPastDates)}
                >
                    {showAllPastDates ? 'See Less' : 'See All'}
                </button>
            )}
        </div>
    );
}

export default ContractUpcomingDates;